module.exports = __webpack_public_path__ + "img/14.c0ec59e1.jpg";